export default "__VITE_ASSET__c7669071__"